<!-- TODO: column id (or other way) to tell how to style this cell -->
<div class="cell-container"
    [class.readonly]="readonly">
    <ng-container *ngIf="readonly | equals:false; else readonlyContent">
        <dropdown-input [value]="value" [nullable]="nullable" (valueChange)="_handleValueChange($event)" [items]="items"
            (focus)="_handleFocus($event)" (blur)="_handleBlur($event)" (keydown)="_handleKeydown($event)">
        </dropdown-input>
    </ng-container>
    <ng-template #readonlyContent>
        <div class="content">{{ value }}</div>
    </ng-template>
</div>